// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"SmartBackup1_TheComp__6Odqn"};